export const CommonConstants = {
    STATE_LIST_REQUEST: 'STATE_LIST_REQUEST',
    USER_LIST_REQUEST: 'USER_LIST_REQUEST',
    SCHEME_LIST_REQUEST: 'SCHEME_LIST_REQUEST',
    GET_ROLE_LIST:'GET_ROLE_LIST',
    FINANCIER_LIST_REQUEST: 'FINANCIER_LIST_REQUEST',
    ROLEWISE_SCHEME_LIST:'ROLEWISE_SCHEME_LIST',
    BM_USER_LIST:"BM_USER_LIST",
    ROLE_PRODUCTS_LIST: "ROLE_PRODUCTS_LIST"
};